module.exports = __webpack_public_path__ + "static/media/add-series.e637260d.svg";